import React, { useEffect, useState } from "react";
import Dashboard from "../dashboard/Dashboard";
import { Spinner } from "../../components";
import "./students.scss";
import { fetchStudents, Student } from "../../services/student.service";
import showToast from "../../utils/show.toast";

interface StudentsData {
  isLoading: boolean;
  students: Student[];
}

function Students() {
  const [studentsData, setStudentsData] = useState<StudentsData>({
    isLoading: true,
    students: [],
  });
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [filterYear, setFilterYear] = useState<string>("");

  useEffect(() => {
    const fetchData = async () => {
      setStudentsData({ isLoading: true, students: [] });
      try {
        const limit = (currentPage - 1) * 20;
        const students = await fetchStudents(20, limit, currentPage);
        setStudentsData({ isLoading: false, students });
      } catch (error) {
        showToast("Error fetching data", false);
        return;
      }
    };

    fetchData();
  }, [currentPage]);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleFilterChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setFilterYear(event.target.value);
    setCurrentPage(1);
  };

  const handleNextPage = () => setCurrentPage((prev) => prev + 1);
  const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));

  return (
    <Dashboard pageTitle="Students">
      <div className="students-page">
        <div className="search-filter">
          <input
            type="text"
            placeholder="Search by student name"
            value={searchTerm}
            onChange={handleSearch}
          />
          <select onChange={handleFilterChange} value={filterYear}>
            <option value="">Filter by enrollment year</option>
            <option value="2022">2022</option>
            <option value="2023">2023</option>
            <option value="2024">2024</option>
          </select>
        </div>

        <div className="students-table">
          {studentsData.isLoading ? (
            <Spinner />
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Firstname</th>
                  <th>Lastname</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                {studentsData.students.map((student) => (
                  <tr
                    key={student.id}
                    onClick={() =>
                      (window.location.href = `/students/${student.id}`)
                    }
                  >
                    <td>{student.firstName}</td>
                    <td>{student.lastName}</td>
                    <td>{student.email}</td>
                    {/* <td>
                      {new Date(student.dateCreated).toLocaleDateString()}
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {/* <div style={{ display: "flex" }}>
            <button onClick={handlePrevPage} disabled={currentPage === 1}>
              Previous
            </button>
            <button onClick={handleNextPage}>Next</button>
          </div> */}
        </div>
      </div>
    </Dashboard>
  );
}

export default Students;
